<div class="nav-container-2 view-container" *ngIf="isViewDoc">
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-3 pr-3">
      <div *ngIf="isViewDoc">
        <mat-tab-group>
          <mat-tab label=""></mat-tab>
          <mat-tab>
              <ng-template mat-tab-label>
                Peer Review No:  {{reviewList.old_Ref_Id}}
                  <i class="fa fa-times-circle ml-3" aria-hidden="true" (click)="closeViewTab(false)"></i>
              </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div> 
  </div>
</div>


<div class="outlet_container">
  <div class="row">
    <div class="col-12">
      <!-- <div style="display: flex;justify-content: left;" *ngIf="!isViewDoc && (Tabname=='Response')">
        <div class="notification">
            <p style="margin-left: 2%;font-style: italic;font-weight: bolder;"><strong style="font-size: large;"><u>Note: </u></strong>
                <br>
                &nbsp;&nbsp;&nbsp;* To enable this page, please ensure your Project Team Members & Disciplines are selected in EIP Staff Selection page 
                <br>
                &nbsp;&nbsp;&nbsp;* To obtain access, kindly contact the relevant EDMS Coordinator.
                <br>
            </p>
        </div>
      </div> -->

      <form [formGroup]="formGroup" autocomplete="off">
      <kendo-grid [kendoGridBinding]="ReviewList" [sortable]="true" [resizable]="true" [filterable]="enableFilter" 
                  [reorderable]="true" [skip]="skip" [pageSize]="15" [pageable]="true" id="grvEDMOrgList" (excelExport)="onExcelExport($event)"
                  (edit)="editRowData($event)" (save)="UpdateRowData($event)" (cancel)="cancelRowData($event)">

        <ng-template kendoPagerTemplate>
          <div class="k-pager-left">
            <kendo-pager-info></kendo-pager-info>
          </div>
          <div class="k-pager-right">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-input></kendo-pager-input>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
          </div>
        </ng-template>

        <ng-template kendoGridToolbarTemplate>
          <div class="k-grid-toolbar-content d-flex justify-content-end">
            <div class="pagination-container">
              <p id="lblShowDetails">Show</p>
              <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
              </kendo-pager-page-sizes>
              <span>Items</span>
            </div>
            <div class="divider-container d-none d-md-block" id="imgDivider">
              <span></span>
            </div>
            <div class="icons-container">
              <div class="d-none d-md-flex align-items-md-center">
                <div class="icon-wrap">
                  <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                  <span class="list-icon-name">Filter</span>
                </div>
              </div>
            </div>
            <div class="icons-container">
              <div class="icon-wrap">
                <button type="button" class="btn btn-primary eip-ml-20 eip-mr-20 eip-p-10"
                  style="background: #1579ab;padding: 5px;" kendoGridExcelCommand icon="file-excel">Export to
                  Excel</button>
              </div>
            </div>
          </div>
        </ng-template>

        <kendo-grid-column title="Req No" width="110" field="old_Ref_Id">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex" let-filter>
            <span class="eip-link" (click)="viewPeerdoc(dataItem)">
              {{dataItem.old_Ref_Id}}
            </span>
          </ng-template>
        </kendo-grid-column>
  
        <kendo-grid-column title="Discipline" field="discipline" width="90">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span class="no-wrap" eipTooltip="{{dataItem.discipline}}" eipTooltipPosition="auto">
              {{dataItem.discipline}}
            </span>
          </ng-template>
        </kendo-grid-column>
  
        <kendo-grid-column title="Status" field="request_Status" width="100">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            {{dataItem.request_Status}}
          </ng-template>
        </kendo-grid-column>
  
        <kendo-grid-column title="Created By" field="created_By" width="110">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            {{dataItem.created_By}}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Created On" field="created_On" width="60">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            {{dataItem.created_On | date:'dd-MMM-yyyy'}}   
          </ng-template>
        </kendo-grid-column>
  
        <kendo-grid-column title="Date & Time of Review" field="date" width="125">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            {{dataItem.date | date:'dd-MMM-yyyy'}}  {{dataItem.time_From}} - {{dataItem.time_To}}
          </ng-template>
          <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex" *ngIf="Tabname=='Status'">
            <EIPDatePicker formControlName="date" WaterMark="scheduled on" [Min]=todaydate [Value]="editedDate" setId="date" (selectedDate)="updatescheduledOn($event)" >
            </EIPDatePicker>
            <app-time-picker [lable]="'scheduled From'" [(inputselectedTime)]="sheduleFrom" (selectedTime)="fromTimeSelected($event,'shFrom')"></app-time-picker>
            <app-time-picker [lable]="'scheduled Upto'" [(inputselectedTime)]="sheduleTo" (selectedTime)="fromTimeSelected($event,'shTo')"></app-time-picker>
            <!-- <mat-form-field WaterMarkText="scheduled From">
              <input matInput type="time" (change)="updatescheduledFrom($event)" formControlName="time_from" setId="time_from" [value]="dataItem.time_from">
            </mat-form-field>
            <mat-form-field WaterMarkText="scheduled Upto">
                <input matInput type="time" (change)="updatescheduledUpto($event)" formControlName="time_to" setId="time_to" [value]="dataItem.time_to">
            </mat-form-field> -->
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Approved By" field="approved_by" width="110" *ngIf="(Tabname!='Status')">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            {{dataItem.approved_by}}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column  title="Approved On" field="approved_on" width="60" *ngIf="(Tabname!='Status')">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            {{dataItem.approved_on | date:'dd-MMM-yyyy'}}
          </ng-template>
        </kendo-grid-column>
  
        <kendo-grid-column title="Status" field="status_Update" width="110" *ngIf="Tabname=='Status'">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <mat-form-field>
              <mat-label>Update Status</mat-label>
              <mat-select [(value)]="dataItem.status_Update">
                <mat-option value={{dataItem.status_Update}}>{{dataItem.status_Update}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
          <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex" *ngIf="Tabname=='Status'">
            
          </ng-template>
        </kendo-grid-column>
  
        <!-- <kendo-grid-column title="Actions" width="50">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <div class="icon-container d-flex">
              <i class="fa fa-save" *ngIf="Tabname=='Status' && pr_status" title="Save" aria-hidden="true" (click)="saveStatus(dataItem)"></i>
              <i class="fa fa-pencil" *ngIf="(Tabname=='Comments' && pr_comments) || (Tabname=='Response' && (pr_response|| edit_res_imp)) || (Tabname=='Impacts' && (pr_impacts|| edit_res_imp))" title="Edit" aria-hidden="true" (click)="viewDocumentClick(dataItem)"></i>
            </div>
          </ng-template>
        </kendo-grid-column> -->
        <kendo-grid-column width="50">
          <ng-template kendoGridHeaderTemplate title="">
            <span style="margin-left: 1%;"></span>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
            <div class="icon-container d-flex">
              <i class="fa fa-save icon-size mr-2" *ngIf="Tabname=='Status' && pr_status && updatestatusbtn" title="Status Update" style="font-size: 20px;" aria-hidden="true" (click)="saveStatus(dataItem)"></i>

              <button kendoGridEditCommand class="k-grid-add-command" *ngIf="(Tabname=='Status') && pr_approval && (dataItem.status_Update == 'Meeting Completed') && pr_status">
                  <i class="fa fa-pencil icon-size mr-2" matTooltip="Re-Schedule And Approve" style="font-size: 20px;" id="" aria-hidden="true"></i>
              </button>
              <button kendoGridSaveCommand type="button" class="k-grid-add-command">
                  <i class="fa fa-save icon-size mr-2" matTooltip="Save" style="font-size: 20px;" id="" aria-hidden="true"></i>
              </button>
              <button kendoGridCancelCommand type="button" class="k-grid-add-command">
                  <i class="fa fa-times-circle icon-size mr-2" matTooltip="Cancel" style="font-size: 20px;" id="" aria-hidden="true"></i>
              </button>
             
              <i class="fa fa-user-plus icon-size mr-2" *ngIf="Tabname=='Status' && pr_status && (edit_res_imp || pr_invite_feature) && updatestatusbtn && (dataItem.status_Update == 'Meeting Completed')" title="Additional Invite" style="font-size: 20px;" (click)="openInvitation(dataItem)"></i>
              <i class="fa fa-pencil icon-size mr-2" *ngIf="(Tabname=='Comments' && pr_comments) || (Tabname=='Response' && (this.pr_response || this.edit_res_imp))" title="Edit" aria-hidden="true" (click)="viewDocumentClick(dataItem)"></i>
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-excel fileName="{{'PeerReview'+Tabname+'.xlsx'}}" [fetchData]="allData"></kendo-grid-excel>
      </kendo-grid>
    </form>
    </div>
  </div>
  
</div>

<div *ngIf="isViewDoc">
  <div>
    <app-add-comments [Data]="reviewList" (exitFunc)="closeViewTab($event)" *ngIf="Tabname=='Comments'"></app-add-comments>
  </div>
  <div>
    <app-add-impacts [Data]="reviewList" (exitFunc)="closeViewTab($event)" *ngIf="Tabname=='Impacts'"></app-add-impacts>
  </div>
  <div>
    <app-add-response [Data]="reviewList" (exitFunc)="closeViewTab($event)" *ngIf="Tabname=='Response'"></app-add-response>
  </div>
  
</div> 
